'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _intro = require('intro.js-react');

var _selectors = require('./selectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TutorialOverlay(_ref) {
  var tutorialOn = _ref.tutorialOn,
      tutorial = _ref.tutorial,
      loading = _ref.loading,
      location = _ref.location,
      toggleTutorial = _ref.toggleTutorial;

  var currentTut = tutorial[location.pathname];

  if (typeof window !== 'undefined' && currentTut) {
    return _react2.default.createElement(_intro.Steps, {
      enabled: tutorialOn,
      steps: currentTut.steps,
      initialStep: 0,
      onExit: function onExit() {
        if (tutorialOn) {
          toggleTutorial();
        }
      },
      onComplete: function onComplete() {
        if (currentTut.nextUrl) {
          if (tutorialOn) {
            toggleTutorial();
          }
          _reactRouter.browserHistory.push(currentTut.nextUrl);
          var reInitTut = function reInitTut() {
            setTimeout(function () {
              if (loading) {
                reInitTut();
              } else {
                toggleTutorial();
              }
            }, 200);
          };
          reInitTut();
        } else {
          toggleTutorial();
        }
      },
      options: {
        doneLabel: currentTut.nextText ? 'Next: ' + currentTut.nextText : 'Done'
      }
    });
  } else {
    return null;
  }
}

exports.default = (0, _reactRedux.connect)(_selectors.mapStateToProps, _selectors.mapDispatchToProps)(TutorialOverlay);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/Tutorial/TutorialOverlay.js
// module id = 1136
// module chunks = 0